/**
 * The visitor's choice about analytics and marketing tags, kept in this
 * browser. Only consulted when the store asks for consent (Marketing →
 * Search & sharing → "Ask visitors…"); otherwise tags load as before.
 */
const KEY = 'marketing_consent';
const listeners = new Set();

export function getConsent() {
  try {
    const value = localStorage.getItem(KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch (e) {
    return null;
  }
}

export function setConsent(value) {
  try { localStorage.setItem(KEY, value); } catch (e) { /* storage blocked: this visit only */ }
  listeners.forEach((fn) => fn(value));
}

/** Forget the choice so the banner asks again ("Cookie settings" in the footer). */
export function resetConsent() {
  try { localStorage.removeItem(KEY); } catch (e) { /* storage blocked */ }
  listeners.forEach((fn) => fn(null));
}

export function onConsentChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Whether analytics/marketing tags may run for this visitor. */
export function consentAllows(required) {
  return !required || getConsent() === 'granted';
}
